<template lang="pug">
.header(:style="headerStyle")
  .container
    router-link(:to="{name: 'home'}")
      .logo
    .navs
      router-link(
        :to="{name: 'home'}",
        :class="{active: $route.name === 'home'}") 首页
      router-link(
        :to="{name: 'home', hash: '#feature'}") 产品特性
      router-link(
        :to="{name: 'home', hash: '#function'}") 功能组件
      router-link(
        :to="{name: 'price'}",
        :class="{active: $route.name === 'price'}") 价格
      a(href="https://help.upyun.com/knowledge-base/cdp-product/", target="_blank") 帮助中心
      router-link(
        :to="{name: 'contact'}",
        :class="{active: $route.name === 'contact'}") 联系我们
    .langing
      a(href="http://console.oncdp.com/#/login",target="_blank") 登录
</template>

<script>
export default {
  name: 'layout-header',
  props: {
    headerBgc: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerStyle() {
      return {
        background: this.headerBgc ? '#00a0ff' : 'none',
        position: this.headerBgc ? 'static' : 'absolute'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.header
  position: absolute
  width: 100%
  color: #ffffff
  z-index: 100


.container
  width: 1170px
  margin: 0 auto
  padding: 30px 0

.logo
  display: inline-block
  width: 165px
  height: 33px
  background-image: url('../assets/logo.svg')
  background-repeat: no-repeat

.navs
  display: inline-block
  width: 722px
  text-align: right
  vertical-align: baseline
  font-size: 16px
  line-height: 2em
  vertical-align: top
  a
    text-decoration: none
    color: rgba(255,255,255,.9)
    margin-left: 60px
    transition: color 0.1s ease-in
    &:hover
      color: rgba(255,255,255,1)
    &.active
      color: rgba(255,255,255,1)


.langing
  display: inline-block
  width: calc(100% - 800px - 87px)
  font-size: 16px
  line-height: 2em
  vertical-align: top
  text-align: right
  a
    text-decoration: none
    color: rgba(255,255,255,.9)
    transition: color 0.1s ease-in
  span
    margin: 0 10px
</style>



// WEBPACK FOOTER //
// header.vue?20b55551